import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/icon-breadcrumb.svg'


const _withScopeId = n => (_pushScopeId("data-v-6fea672b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "breadcrumb" }
const _hoisted_2 = ["alt"]

import { computed, watchEffect } from "vue";
import { useHistoryStore } from "@/stores/use-history-store";
import i18n from "@/i18n/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadcrumbComponent',
  setup(__props) {

const isLoggedIn = computed(() => sessionStorage.getItem("user"));
const { getLastRoutesAcessed } = useHistoryStore();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_VBreadcrumbs = _resolveComponent("VBreadcrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: isLoggedIn.value ? '/admin/' : '/'
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _imports_0,
          alt: isLoggedIn.value ? 'Dashboard' : 'Home'
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode(_component_VBreadcrumbs, {
      items: _unref(getLastRoutesAcessed)(4)
    }, {
      divider: _withCtx(() => [
        _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}
}

})